import * as React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: normal;
`;
const TextOverflowEllipsis = ({ children, titleOverride = void 0, className = void 0 }) => /* @__PURE__ */ React.createElement(Wrapper, { title: titleOverride || children, className }, children);
export default TextOverflowEllipsis;
